const getAccesories = (accesoriesInnerContainerElement, successCallback) => {
    const parentDealId = document.querySelector('input[name="line"]').value;
    const dealId = document.querySelector('div#package_info').getAttribute('data-hstarid');
    let excludeIds = '';
    document.querySelectorAll('div[data-basket-accesories-added]').forEach((element, index) => {
        excludeIds = excludeIds + (index > 0 ? ',' : '') + element.getAttribute('data-basket-accesories-added');
    });

    const baseurl = `/ajax/related-products.json?parentId=${parentDealId}&dealId=${dealId}&excludeIds=${excludeIds}&limit=5`;

    fetch(baseurl)
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error ${response.status}`);
            }
            return response.json();
        })
        .then((responseData) => {
            successCallback(accesoriesInnerContainerElement, responseData.data);
        })
        .catch((err) => {
            if (document.querySelector('div[data-basket-accessories-wrapper]')) {
                document.querySelector('div[data-basket-accessories-wrapper]').classList.add('hidden');
            }
            // eslint-disable-next-line no-console
            console.error('There was some trouble loading accesories: ', err);
        });
};

const showAccesoriesSectionInBasket = (accesoriesInnerContainerElement, accesories) => {
    let accesoriesListingElement = '';
    if (accesories.relatedDeals === undefined || accesories.relatedDeals.length == 0) {
        if (document.querySelector('div[data-basket-accessories-wrapper]')) {
            document.querySelector('div[data-basket-accessories-wrapper]').classList.add('hidden');
        }
        return false;
    }
    accesories.relatedDeals.forEach((element) => {
        accesoriesListingElement = ` ${accesoriesListingElement}
		<div class="h-auto swiper-slide" data-basket-accessory-dealid="${element.hstarid}">
			<div class="flex flex-col items-center justify-center m-0 panel panel-default bg-offwhite p-15px h-100">
				<div class="pb-15px">
					<img src="${element.productImageUrl}" alt="${element.productUrlName}" height="150px"/>
				</div>
				<div class="text-center pb-15px">
					<h3 class="m-0 font-medium text-14px min-h-40px line-clamp-2" title="${element.productUrlName}">${element.productUrlName}</h3>
				</div>
				<div class="text-center pb-15px">
                    <p class="m-0 font-medium text-20px basket-accessory-price">&pound;${element.dealPrice}</p>
				</div>
				<div class="text-center w-100">
				<form method="POST" action="/continue-to-basket">
					<input type="hidden" name="itemType" value="deal">
					<input type="hidden" name="itemData[dealId]" value="${element.hstarid}">
					<input type="hidden" name="itemData[giftCode]" value="${element.giftCode}">
					<input type="hidden" name="itemData[isStaticGift]" value="${element.isStaticGift != false ? element.isStaticGift : ''}">
					<input type="hidden" name="itemData[parentId]" value="${accesories.parentId}">
                    <button tabindex="0" class="m-0 panel w-100 py-10px px-15px basket-accessory-cta">
                        <span class="font-semibold text-16px">ADD TO BASKET</span>
					</button>
				</form>
				</div>
			</div>
		</div>
		`;
    });
    if (document.querySelector('div#accessories_loader')) {
        document.querySelector('div#accessories_loader').style.display = 'none';
    }
    accesoriesInnerContainerElement.insertAdjacentHTML('afterbegin', accesoriesListingElement);
    // document.querySelector('div[data-basket-accessories-wrapper]').classList.remove('hidden');
    // Enable loader when accessory is added to basket
    document.querySelectorAll('form[action="/continue-to-basket"').forEach((formElement) => {
        formElement.addEventListener('submit', () => {
            document.querySelector('div#page_loader').style.display = 'flex';
        });
    });
};

window.addEventListener('DOMContentLoaded', () => {
    // Enable loader when product (including accessory) is removed from basket
    document.querySelectorAll('form[action="/checkout/remove"').forEach((formElement) => {
        formElement.addEventListener('submit', () => {
            document.querySelector('div#page_loader').style.display = 'flex';
        });
    });
    const accesoriesInnerContainerElement = document.querySelector('div[data-basket-accessories-inner-container]');
    if (!accesoriesInnerContainerElement) {
        return false;
    }
    getAccesories(accesoriesInnerContainerElement, showAccesoriesSectionInBasket);
});
